module.exports = __webpack_public_path__ + "img/jins2.1ee4705d.jpg";